import { dateOnlyOf } from '@/lib/utils/custom-date/custom-date';
import { Holiday } from '../types/holiday.types';

/** The holiday's day ("YYYY-MM-DD"). `StartDate` is date only (the day at 00:00:00 UTC), so it is read by
 * its date part and never converted to a zone. Rows saved before that rule hold the organization's day
 * start (e.g. `2026-12-15T18:00:00Z` for 16 Dec in Dhaka); `dateOnlyOf` still reads those right. */
export const holidayDay = (holiday: Pick<Holiday, 'StartDate'>): string => dateOnlyOf(holiday.StartDate);
